import { models } from '@tfo/common'
import * as React from 'react'
import { useState } from 'react'
import { observer } from 'mobx-react'
import ReportsItemDate from './ReportsItemDate'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import '../ReportsItem.scss'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { ClientViewStore } from '../../../../../../../stores/ClientViewStore'
import { IOrderClient } from '@tfo/common/src/models/Interfaces'
import ReportsItemWaitingApproval from './ReportsItemWaitingApproval'

export interface ReportsItemWaitingApprovalProps {
	data: models.IGroupOrder
	reportPackages: models.ReportPackage[]
	showCompanyName: boolean
	store: ClientViewStore
}

const ReportsItemGroupWaitingApproval = ({
	data,
	intl,
	reportPackages,
	showCompanyName,
	store,
}: ReportsItemWaitingApprovalProps & WrappedComponentProps) => {
	const [isExpanded, setIsExpanded] = useState<boolean>(false)

	const onUpdateOrder = (order: IOrderClient): void => {
		const index = store.reportsStore.orders.findIndex(x => x.id === order.id)
		store.reportsStore.orders[index] = order
	}

	const onRemoveOrder = (order: IOrderClient): void => {
		store.reportsStore.removeOrder(order);
	}
	
	return (
		<div
			data-expanded={isExpanded}
			className={'ReportsItem ReportsItem--standard ReportsItem--active ReportsItem__Group'}
			id={'reportsItem_' + data.id.toString()}>
			<div className={'ReportsItem__Inner ReportsItem__Expanded'}
				onClick={() => setIsExpanded(!isExpanded)}>
				{showCompanyName && (
					<div className={'ReportsItem__Cell'}>{data.orders[0].companyName}</div>
				)}
				<div className={'ReportsItem__Cell'}>
					{reportPackages.find(x => x.id === data.orders[0].servicePackageId)
						?.customName ?? ''}
				</div>
				<div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}>
					{intl.formatMessage({ id: 'client.reports.item.grouporder' })}
				</div>
				<div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}>
					{intl.formatMessage({ id: 'client.reports.item.amount' })}:&nbsp;
					{data.orders.length}
				</div>
				<div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}></div>
				<ReportsItemDate
					date={data.orders[0].created}
					label={intl.formatMessage({ id: 'common.ordered' })}
				/>
				<KeyboardArrowDownIcon className={'ReportsItem__Group__Indicator'}  />
			</div>
			{isExpanded &&
				<div className='ReportsItem ReportsItem__Group--expanded'>
					{data.orders
						.filter(o => o.state === 'WaitingForConsent')
						.map((o, index) => <ReportsItemWaitingApproval
							data={o}
							key={'reportsItem_' + o.id + index}
							reportPackages={reportPackages}
							showCompanyName={false}
							updateOrder={onUpdateOrder}
							removeOrder={onRemoveOrder}
						/>)}
				</div>}
		</div>
	)
}
export default injectIntl(observer(ReportsItemGroupWaitingApproval))